module.exports = __webpack_public_path__ + "img/thinking_face-cuate.255d7c76.svg";